import Link from 'next/link'
import React from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

type Props = {
  name: string
  className?: string
}

const ColumnLink = ({ text, link }) => {
  return (
    <div className="mb-6">
      {link !== '' && (
        <Link href={link} className={'text-white underline hover:!text-peach-400'}>
          {text}
        </Link>
      )}
    </div>
  )
}

const FooterColumn: React.FC<Props> = ({ name, className }) => {
  const { t } = getTranslate()

  return (
    <div className={className}>
      <h2 className="mb-8 text-xl font-bold text-pink-500">{t(`component.footer.${name}Column.title`)}</h2>
      <div className="text-sm">
        <ColumnLink
          text={t(`component.footer.${name}Column.first`)}
          link={t(`component.footer.${name}Column.firstLink`)}
        />
        <ColumnLink
          text={t(`component.footer.${name}Column.second`)}
          link={t(`component.footer.${name}Column.secondLink`)}
        />{' '}
        <ColumnLink
          text={t(`component.footer.${name}Column.third`)}
          link={t(`component.footer.${name}Column.thirdLink`)}
        />
      </div>
    </div>
  )
}

export default FooterColumn
